import { render, staticRenderFns } from "./dialogModal.vue?vue&type=template&id=0567d735&"
import script from "./dialogModal.vue?vue&type=script&lang=js&"
export * from "./dialogModal.vue?vue&type=script&lang=js&"
import style0 from "./dialogModal.vue?vue&type=style&index=0&id=0567d735&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports